<template>
    <homework>
        <template #homework-content>
            <div v-if="isLoading"></div>
            <div v-else>
                <div v-if="homeworkStore.expiredHomeworks.length">
                    <homework-list v-for="homework in getHomeworkList" 
                        :key="homework.id"
                        :homework="homework"
                        :is-open="accordionIsOpen(homework.id)"
                        :is-current="false"
                    ></homework-list>
                    <div class="c-pagination" v-if="getHomeworkListLength > per_page">
                        <span @click="goToPrevPage" :class="{'c-pagination__page':true, 'c-pagination__page--prev': true, 'c-pagination__page--disabled': current_page===1}"></span>
                        <template v-for="page in total_pages">
                            <span v-if="page === 0" class="c-pagination__page--ellipsis"></span>
                            <span v-else
                                @click="goToPage(page)"
                                :class="{'c-pagination__page':true, 'c-pagination__page--act': page===current_page}">{{ page }}
                            </span>
                        </template>
                        <span @click="goToNextPage" :class="{'c-pagination__page':true, 'c-pagination__page--next':true, 'c-pagination__page--disabled': current_page===max_page}"></span>
                    </div>
                </div>
                <div v-else>
                    <p class="p-homework-no-data">「過去の宿題」はありません。</p>
                </div>
            </div>
        </template>
    </homework>
</template>
<script setup lang="ts">
  import {ref, computed, onMounted, watch} from "vue";
  import {useRoute, useRouter} from "vue-router"
  import {HOMEWORK_PROGRESS} from "@/consts/homework";
  import { useHomeworkStore } from '@/store/student/homework_store';

  const homeworkStore = useHomeworkStore()
  const route = useRoute()
  const router = useRouter()

  // this flag is used for show initial dispaly until fetch expiredHomework
  const isLoading = ref(true)
  const per_page = ref(10)
  const current_page = ref(1)
  const total_pages = ref([])
  const max_page = ref(1)
  // save current selected page if toggle switch press
  const toggle_current_page = ref(1)

  const getHomeworkList = computed(() => {
      if(homeworkStore.isHomeworkCompleted){
          return homeworkStore.expiredHomeworks.filter(homework => homework.homework_status === HOMEWORK_PROGRESS.NOTSTARTED || homework.homework_status == HOMEWORK_PROGRESS.INPROGRESS)
              .slice((current_page.value-1)*per_page.value, current_page.value*per_page.value)
              .sort(function(a,b) {return new Date(a.end_datetime).getTime() - new Date(b.end_datetime).getTime()})
      }
      return homeworkStore.expiredHomeworks.sort(function(a,b) {return new Date(a.end_datetime).getTime() - new Date(b.end_datetime).getTime()})
          .slice((current_page.value-1)*per_page.value, current_page.value*per_page.value)
  })

  const getHomeworkListLength = computed(() => {
      if(homeworkStore.isHomeworkCompleted){
          return homeworkStore.expiredHomeworks.filter(homework => homework.homework_status === HOMEWORK_PROGRESS.NOTSTARTED || homework.homework_status == HOMEWORK_PROGRESS.INPROGRESS).length
      }
      return homeworkStore.expiredHomeworks.length
  })
  onMounted(async() => {
      // Remove the class that prohibits outside (body) scrolling when returning from S3-7, 8, 9 screens with inside scrolling
      let body_tag = document.getElementsByTagName('body')[0]
      body_tag.classList.remove("unscrollable")
      // save query string for direct go to page number
      let p = route.query.p as string
      if(route.query.p && /^\d+$/.test(p)){
          current_page.value = parseInt(p)
          toggle_current_page.value = parseInt(p)
      }
      homeworkStore.saveIsHomeworkCurrent(false)
      await homeworkStore.fetchExpiredHomework()
      max_page.value = Math.ceil(getHomeworkListLength.value/per_page.value) || 1
      total_pages.value = pagination(current_page.value, max_page.value)
      isLoading.value = false
  })

  function accordionIsOpen(hw_id: number){
      // fetch the homework_id is open or not
      let isOpen = homeworkStore.homeworkAccordion[hw_id]
      // check hw_id is in last session or not
      if(isOpen !== undefined){
          return isOpen
      }
      return false
  }

  function goToPrevPage(){
    router.replace({ name: "expired-homework", query: {p: `${current_page.value-1}`}})
  }
  function goToPage(page: number){
    router.replace({ name: "expired-homework", query: {p: `${page}`}})
  }
  function goToNextPage(){
    router.replace({ name: "expired-homework", query: {p: `${current_page.value+1}`}})
  }
  function pagination(current: number, max: number) {
      if (!current || !max) return []
      let items: Array<number> = [1]
      if (current === 1 && max === 1) return items
      // items array contain `0` element to indecate ellipses
      if (current > 4) items.push(0)
      let r = 2, r1 = current - r, r2 = current + r
      for (let i = r1 > 2 ? r1 : 2; i <= Math.min(max, r2); i++) items.push(i)
      if (r2 + 1 < max) items.push(0)
      if (r2 < max) items.push(max)
      return items
  }
  // watch toggle switch button to fix pagination
  watch(
    () => homeworkStore.isHomeworkCompleted, 
    (newVal) => {
      max_page.value = Math.ceil(getHomeworkListLength.value/per_page.value) || 1
      if(newVal){
        // save current page
        toggle_current_page.value = current_page.value
      } else {
        // retrive current page
        current_page.value = toggle_current_page.value
      }
      // set current_page if current_page is getter than max_page
      if(current_page.value > max_page.value) {
        current_page.value = max_page.value
      }
      total_pages.value = pagination(current_page.value, max_page.value)
    },
  )
</script>